import type { SearchResultSetV1, SubstrateSearchResponseV1, } from "../../data/schema/SubstrateSearchResponse";
import type { ResultSet, SubstrateSearchQueryResponse } from "@1js/3s-schema";
import { logUsage } from "owa-analytics";
import { getModuleContextMailboxInfo } from "owa-module-context-mailboxinfo";

export default function getSearchResultSet(responseBody: SubstrateSearchQueryResponse | SubstrateSearchResponseV1): ResultSet | SearchResultSetV1 | null {
    const entitySetsCount = responseBody?.EntitySets?.length ?? 0;
    const resultSetsCount = responseBody?.EntitySets?.[0]?.ResultSets?.length ?? 0;
    
    if (entitySetsCount !== 1 || resultSetsCount !== 1) {
        logUsage("SearchResult_InvalidResultSet", getModuleContextMailboxInfo(), {
            EntitySetsCount: entitySetsCount,
            ResultSetsCount: resultSetsCount,
        });
    }
    
    if (responseBody?.EntitySets?.[0]?.ResultSets?.[0]) {
        return responseBody.EntitySets[0].ResultSets[0];
    }
    
    return null;
}
